import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { BASE_URL, BASE_FILEURL } from '../components/constants'
import { authHeader } from '../utils/authHeaders';

// Async thunks
export const fetchDefaultFiles = createAsyncThunk(
  'defaultFiles/fetchDefaultFiles',
  async ({ organizationId, taskId }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams()
      if (organizationId) params.append('organization_id', organizationId)
      if (taskId) params.append('task_id', taskId)
      
      const url = `${BASE_FILEURL}/default?${params}`;
      
      const response = await axios.get(url, {
        headers: {
          ...authHeader()
        }
      })
      
      return response.data.files || []
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || 'Failed to fetch default files')
    }
  }
)

const defaultFilesSlice = createSlice({
  name: 'defaultFiles',
  initialState: {
    files: [],
    loading: false,
    error: null
  },
  reducers: {
    clearDefaultFiles: (state) => {
      state.files = []
      state.error = null
    },
    addLocalFile: (state, action) => {
      state.files = [action.payload, ...state.files]
    },
    removeLocalFile: (state, action) => {
      state.files = state.files.filter(f => f.id !== action.payload)
    },
    removeLocalFiles: (state, action) => {
      const idsToRemove = new Set(action.payload)
      state.files = state.files.filter(f => !idsToRemove.has(f.id))
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDefaultFiles.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchDefaultFiles.fulfilled, (state, action) => {
        state.loading = false
        state.files = action.payload
      })
      .addCase(fetchDefaultFiles.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  }
})

export const { clearDefaultFiles, addLocalFile, removeLocalFile, removeLocalFiles } = defaultFilesSlice.actions
export default defaultFilesSlice.reducer
